<template>
  <div>
    <p v-if="!hasUnbanId">
      unban id unknown
    </p>
    <player-unban-link
      v-if="hasUnbanId"
      :playerId="action.playerId"
      :unbanId="action.unbanId"
      lable="unban"
    />
  </div>
</template>

<script>
import PlayerUnbanLink from './PlayerUnbanLink.vue';

export default {
  name: 'UserActionInfoUnbanPlayer',

  components: {
    PlayerUnbanLink,
  },

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasUnbanId() {
      return 'unbanId' in this.action;
    },
  },
};
</script>
